(() => {
  const enhanceGallery = (root) => {
    root.classList.add('sb-pdp');
    const viewer = root.querySelector('[id^="GalleryViewer-"]');
    const track = viewer?.querySelector('[id^="Slider-Gallery-"]');
    if (!viewer || !track) return;
    const slides = Array.from(track.children);
    viewer.dataset.sbSingle = String(slides.length < 2);
    const counter = viewer.querySelector('.slider-counter');
    counter?.setAttribute('aria-live', 'polite');
    counter?.setAttribute('aria-atomic', 'true');
    track.setAttribute('tabindex', '0');
    if (!track.dataset.sbKeyboard) {
      track.dataset.sbKeyboard = 'true';
      track.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        if (event.target !== track) return;
        event.preventDefault();
        let left = track.scrollLeft;
        if (event.key === 'ArrowLeft') left -= track.clientWidth;
        if (event.key === 'ArrowRight') left += track.clientWidth;
        if (event.key === 'Home') left = 0;
        if (event.key === 'End') left = track.scrollWidth;
        track.scrollTo({left});
      });
    }
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (slides.length > 1 && typeof viewer.resetPages === 'function') viewer.resetPages();
    }));
  };
  const setup = () => {
    document.querySelectorAll('[data-sb-product-assets]').forEach((marker) => {
      const root = marker.closest('product-info');
      if (root) enhanceGallery(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true});
  else setup();
  document.addEventListener('shopify:section:load', setup);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(setup));
  }
  if (customElements.get('sb-klarna')) return;
  customElements.define('sb-klarna', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.root = this.closest('product-info');
      this.price = Number(this.dataset.price);
      this.trigger = this.querySelector('.sb-klarna-trigger');
      this.dialog = this.querySelector('dialog');
      this.formatter = new Intl.NumberFormat(this.dataset.locale || 'fr-FR', {style:'currency',currency:this.dataset.currency || 'EUR'});
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.trigger.addEventListener('click', () => {
        this.renderAmounts();
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('sb-klarna-open');
      }, options);
      this.querySelector('.sb-klarna-close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('sb-klarna-open');
        this.trigger.focus();
      }, options);
      this.root?.addEventListener('input', (event) => {
        if (event.target.matches('input[name="quantity"]')) this.renderAmounts();
      }, options);
      this.root?.addEventListener('change', (event) => {
        if (event.target.matches('input[name="quantity"]')) this.renderAmounts();
      }, options);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
          if (payload.data.sectionId !== this.root?.dataset.section) return;
          this.hidden = !payload.data.variant?.available;
          if (payload.data.variant?.price != null) this.price = Number(payload.data.variant.price);
          this.renderAmounts();
        });
      }
      this.renderAmounts();
    }
    renderAmounts() {
      const quantity = Math.max(1, Number(this.root?.querySelector('input[name="quantity"]')?.value) || 1);
      const total = Math.round(this.price * quantity);
      const first = Math.round(total / 3);
      const last = total - first * 2;
      this.querySelectorAll('[data-sb-first], [data-sb-second]').forEach((node) => node.textContent = this.formatter.format(first / 100));
      this.querySelectorAll('[data-sb-third]').forEach((node) => node.textContent = this.formatter.format(last / 100));
      this.querySelectorAll('[data-sb-total]').forEach((node) => node.textContent = this.formatter.format(total / 100));
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.unsubscribe?.();
      this.initialised = false;
      if (this.dialog?.open) document.documentElement.classList.remove('sb-klarna-open');
    }
  });
})();
